import { labeled, numberRequired } from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  Joi.object().keys({
    proposedLoanAmount: numberRequired(Joi, 1).label(labeled(label, 'Proposed loan amount'))
  });

export default {
  schema
};
